import React, { useState, useEffect } from 'react';
import {
    Table, Button, Drawer, KeyValuePairs, Badge, Container, FormField, Input, TimeInput, Grid,
    Form, Cards, CardsProps, Box, SpaceBetween, BreadcrumbGroup,
    NonCancelableCustomEvent,
    FlashbarProps,
    Flashbar,
    Multiselect,
    MultiselectProps
} from '@cloudscape-design/components';

import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { getParameter } from '../../../commons/functions';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import DatePickerModal from '../../../../components/DatePickerModal';

const pageSize = 20;


type PolicyItem = {
    idPolicy: number;
    policy: string;
    startTime: string;
    endTime: string;
    fechaInicio: string;
    fechaTermino: string;
    weekDay: string;
    weekDayString: string;
};
type DayItem = { label: string; value: string, number: number };
type GroupedDayOption = {
    label: string; options: DayItem[];
};
const days: DayItem[] = [
    { label: 'Lunes', value: '1', number: 1 },
    { label: 'Martes', value: '2', number: 2 },
    { label: 'Miércoles', value: '3', number: 3 },
    { label: 'Jueves', value: '4', number: 4 },
    { label: 'Viernes', value: '5', number: 5 },
    { label: 'Sábado', value: '6', number: 6 },
    { label: 'Domingo', value: '7', number: 7 },
    { label: 'Festivos', value: '0', number: 0 },
];
const optionsDays: GroupedDayOption[] = [
    {
        label: "Semana",
        options: [
            { label: "Lunes", value: "1", number: 1 },
            { label: "Martes", value: "2", number: 2 },
            { label: "Miércoles", value: "3", number: 3 },
            { label: "Jueves", value: "4", number: 4 },
            { label: "Viernes", value: "5", number: 5 },
        ],
    },
    {
        label: "Fin de Semana",
        options: [
            { label: "Sábado", value: "6", number: 6 },
            { label: "Domingo", value: "7", number: 7 },
        ],
    },
    {
        label: "Otros",
        options: [
            { label: "Feriados", value: "0", number: 0 },
        ],
    },
];
const allDayItems: DayItem[] = optionsDays.flatMap(group => group.options);

export const SecurityPoliciyEditPage = () => {
    const storeAdmin = useStoreAdmin();
    const { idPropiedad, setIdPropiedad, JWT, setJWT } = useGlobalState();
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const { setLoading } = useGlobalState();
    const [itemPolicy, setItemPolicy] = useState<PolicyItem>();
    const [policy, setPolicy] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    const [selectedItems, setSelectedItems] = useState<DayItem[]>([]);
    const [selectedDays, setSelectedDays] = useState<string[]>([]);
    const [selectedDaysNumbers, setSelectedDaysNumbers] = useState<number[]>([]);

    const id = getParameter(window.location.hash, 'id');

    const [modalDateStartOpen, setModalDateStartOpen] = useState(false);
    const [modalDateEndOpen, setModalDateEndOpen] = useState(false);


    const [dateFechaInicio, setDateFechaInicio] = React.useState("");
    const [dateFechaTermino, setDateFechaTermino] = React.useState("");
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);


    const handleSelectionChange = (
        selected: readonly MultiselectProps.Option[]
    ) => {
        const fullSelectedDayItems = allDayItems.filter(day =>
            selected.some(option => option.value === day.value)
        );

        setSelectedItems(fullSelectedDayItems);
        setSelectedDays(fullSelectedDayItems.map(item => item.value));
        setSelectedDaysNumbers(fullSelectedDayItems.map(item => item.number));
    };

    const handleUpdatePolicy = async () => {
        try {

            let body = {
                idPolicy: id,
                policy: policy,
                startTime: startTime,
                endTime: endTime,
                weekDay: selectedDaysNumbers.sort((a, b) => a - b).join(""),
                fechaInicio: dateFechaInicio,
                fechaTermino: dateFechaTermino,
            };
            if (policy.trim() === "") {
                setMessages([
                    {
                        type: 'error',
                        content: "Debe ingresar el nombre de la política",
                        id: 'server-error',
                    },
                ]);
                return;
            }
            if (startTime.trim().length !== 5) {
                setMessages([
                    {
                        type: 'error',
                        content: "Debe ingresar la hora de inicio de la política",
                        id: 'server-error',
                    },
                ]);
                return;
            }
            if (endTime.trim().length !== 5) {
                setMessages([
                    {
                        type: 'error',
                        content: "Debe ingresar la hora de término de la política",
                        id: 'server-error',
                    },
                ]);
                return;
            }
            if (selectedDaysNumbers.length === 0) {
                setMessages([
                    {
                        type: 'error',
                        content: "Debe seleccionar al menos un día de la semana",
                        id: 'server-error',
                    },
                ]);
                return;
            }
            setLoading(false)
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/security/policies/update',
                    JWT: JWT,
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.JWTRenew && data.JWTRenew !== '') {
                setJWT(data.JWTRenew);
            }
            if (data.code === 0) {
                window.location.hash = `#security/policies`;
            }

        } catch (error) {
            console.error('Error fetching policy:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleRefresh = async () => {
        try {
            setLoading(true)
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/security/policies/get',
                    JWT: JWT,
                },
                body: JSON.stringify({
                    idPolicy: id,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.JWTRenew && data.JWTRenew !== '') {
                storeAdmin(data);
            }
            const selectedDayValues = data.policy.weekDay.split("");

            // Convert weekDay string to array of numbers
            setSelectedDaysNumbers(data.policy.weekDay.split("").map(Number));
            const matchedItems = allDayItems.filter(day => selectedDayValues.includes(day.value));
            setSelectedItems(matchedItems);

            // Set other policy states
            setItemPolicy(data.policy);
            setPolicy(data.policy.policy);
            setStartTime(data.policy.startTime);
            setEndTime(data.policy.endTime);
            setDateFechaInicio(data.policy.fechaInicio);
            setDateFechaTermino(data.policy.fechaTermino);

        } catch (error) {
            console.error('Error fetching policy:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        console.log("selectedItems")
        console.log(selectedItems)
    }, [selectedItems]);
    useEffect(() => {
        handleRefresh();
    }, []);

    return (
        <CustomAppLayout
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Seguridad', href: '#security' },
                        { text: 'Políticas', href: '#security/policies' },
                        { text: 'Editar', href: '#' },
                    ]}
                    expandAriaLabel="Mostrar ruta"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <Container header={<h2>Editar política</h2>}>
                    <Form
                        actions={
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button formAction="none" variant="link" href="#security/policies">
                                    Cancelar
                                </Button>
                                <Button variant="primary" onClick={handleUpdatePolicy}>Actualizar</Button>
                            </SpaceBetween>
                        }
                    >
                        <Flashbar items={messages}></Flashbar>
                        <Grid gridDefinition={[{ colspan: 6 }, { colspan: 3 }, { colspan: 3 }]}>
                            <FormField label="Glosa" constraintText="Texto descriptivo de la política">
                                <Input value={policy} onChange={(e) => setPolicy(e.detail.value)} />
                            </FormField>
                            <FormField label="Inicio" constraintText="Horario de activación de la política">
                                <TimeInput
                                    value={startTime}
                                    onChange={(e) => setStartTime(e.detail.value)}
                                    format="hh:mm"
                                />
                            </FormField>
                            <FormField label="Término" constraintText="Horario de desactivación de la política">
                                <TimeInput
                                    value={endTime}
                                    onChange={(e) => setEndTime(e.detail.value)}
                                    format="hh:mm"
                                />
                            </FormField>
                        </Grid>
                        
                        <FormField label={`Días de la semana${selectedItems.length > 0 ? ` (${selectedItems.length}/${days.length})` : ''}`}>
                            <Multiselect
                                selectedOptions={selectedItems.map(({ label, value }) => ({ label, value }))}
                                onChange={({ detail }) => handleSelectionChange(detail.selectedOptions)}
                                options={optionsDays}
                                placeholder="Selecciona días"
                                filteringType="auto"
                                ariaLabelledby="days-multiselect"
                            />
                        </FormField>
                        <h4>Fechas de inicio y término (opcionales)</h4>
                        <SpaceBetween direction="horizontal" size="xs">
                            <FormField label="Activa desde">
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Input
                                        value={dateFechaInicio}
                                        readOnly
                                        placeholder="Inicio"
                                    />
                                    <Button
                                        iconName="calendar"
                                        onClick={() => setModalDateStartOpen(true)}
                                    />
                                </SpaceBetween>
                            </FormField>

                            <FormField label="Activa hasta">
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Input
                                        value={dateFechaTermino}
                                        readOnly
                                        placeholder="Término"
                                    />
                                    <Button
                                        iconName="calendar"
                                        onClick={() => setModalDateEndOpen(true)}
                                    />
                                </SpaceBetween>
                            </FormField>

                        </SpaceBetween>
                    </Form>
                    <DatePickerModal
                        visible={modalDateStartOpen}
                        clear={true}
                        close={true}
                        start={new Date}
                        title='Seleccione'
                        subTitle='Fecha de activación'
                        onDismiss={() => {
                            setModalDateStartOpen(false)
                        }}
                        onConfirm={(date) => {
                            setModalDateStartOpen(false);
                            setDateFechaInicio(date)
                        }}
                    />
                    <DatePickerModal
                        visible={modalDateEndOpen}
                        clear={true}
                        close={true}
                        start={new Date}
                        title='Seleccione'
                        subTitle='Fecha de finalización'
                        onDismiss={() => {
                            setModalDateEndOpen(false)
                        }}
                        onConfirm={(date) => {
                            setModalDateEndOpen(false);
                            setDateFechaTermino(date)
                        }}
                    />
                </Container>
            }
        />
    );
};
